import { useEffect, useState } from "react";
import { getAccount } from "@/api/accountApi";
interface UseFreeAccountCheckInput {
  userId: string | null;
}

export function useFreeAccountCheck({ userId }: UseFreeAccountCheckInput) {
  const [isFreeAccount, setIsFreeAccount] = useState(false);
  const [isLoadingAC, setIsLoadingAC] = useState(false);

  useEffect(() => {



    async function checkAccount() {

      let createdAt;
      if (!userId) {
        setIsFreeAccount(false);
        setIsLoadingAC(false);
        return;
      }

      setIsLoadingAC(true);

      try {
        const account = await getAccount();
        createdAt = account?.createdAt;

      } catch {
        console.log("Error getting users createdAt")
      }

      let trialEndDate = new Date(createdAt)

      // TODO: decide when free trial ends
      trialEndDate.setMonth(trialEndDate.getMonth() + 4);

      setIsFreeAccount(trialEndDate > new Date());
    }

    checkAccount();

    return () => {
    };
  }, [userId]);

  return {
    isFreeAccount,
    isLoadingAC,
  };
}
